import React, { useMemo } from "react";
import cloudStore from "../../../store/CloudStore";
import Paynl from "./Paynl";

export default function Paynls(){

  const paynlMerchants = useMemo(() => {
    const paynlMerchants = [...cloudStore.merchant.paynl_merchants];
     paynlMerchants.push(null)
    return paynlMerchants;
  });


  return paynlMerchants.map((paynlMerchant) => {
    return <Paynl paynlMerchant={paynlMerchant}/>
  })
}